import Book from './Book';
import BookForm from './BookForm';

const AddBook = () => (
  <div>
    <Book />
    <BookForm />
  </div>
);

export default AddBook;
